import { useTranslation } from 'react-i18next';
import { ProductAvailability } from '@types';

export const useProductAvailability = () => {
    const { t } = useTranslation();

    const translations = {
        inStock: t('product-availability.in-stock'),
        outOfStock: t('product-availability.out-of-stock'),
    };

    return {
        translateAvailability: (availability: ProductAvailability) => {
            switch (availability) {
                case ProductAvailability.inStock:
                    return translations.inStock;
                case ProductAvailability.outOfStock:
                    return translations.outOfStock;
                default:
                    return '';
            }
        },
        getAvailabilityTypographyColor: (availability: ProductAvailability) => {
            switch (availability) {
                case ProductAvailability.outOfStock:
                    return 'danger-dark';
                default:
                    return 'primary';
            }
        },
    };
};
